import axios from 'axios';

const BASE_API_ENDPOINT = 'https://us-central1-eth-fighter.cloudfunctions.net/main/api/network';

export default new class ApiService {
  async getAccountTokens(chainId, account) {
    return (await axios.get(`${BASE_API_ENDPOINT}/${chainId}/account/${account}/tokens`)).data;
  }
}